export const SDK_VERSION = "2.17.0";
